import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const DataDisplayIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Opening brace */}
      <path d="M4 4c-1 0-2 1-2 2v4c0 1-1 2-2 2 1 0 2 1 2 2v4c0 1 1 2 2 2" />
      {/* Closing brace */}
      <path d="M20 4c1 0 2 1 2 2v4c0 1 1 2 2 2-1 0-2 1-2 2v4c0 1-1 2-2 2" />
      {/* Data dots */}
      <circle cx="8" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="16" cy="12" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
});

DataDisplayIcon.displayName = 'DataDisplayIcon';
